import React from 'react';
import { CurrencyProvider } from './contexts/CurrencyContext';
import { HeroSection } from './components/HeroSection';
import { TicketDivider } from './components/TicketDivider';
import { PainSection } from './components/PainSection';
import { MemorySection } from './components/MemorySection';
import { ProductReveal } from './components/ProductReveal';
import { MechanismSection } from './components/MechanismSection';
import { AudienceSection } from './components/AudienceSection';
import { AfterSection } from './components/AfterSection';
import { WhatYouGet } from './components/WhatYouGet';
import { PricingSection } from './components/PricingSection';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
export function App() {
  return <CurrencyProvider data-id="element-0">
      <main className="min-h-screen w-full bg-[#FDF8F4] overflow-x-hidden" data-id="element-1">
        <HeroSection data-id="element-2" />

        <TicketDivider data-id="element-3" />
        <PainSection data-id="element-4" />

        <TicketDivider data-id="element-5" />
        <MemorySection data-id="element-6" />

        <ProductReveal data-id="element-7" />

        <TicketDivider data-id="element-8" />
        <MechanismSection data-id="element-9" />

        <AudienceSection data-id="element-10" />

        <TicketDivider data-id="element-11" />
        <AfterSection data-id="element-12" />

        <WhatYouGet data-id="element-13" />

        <TicketDivider data-id="element-14" />
        <PricingSection data-id="element-15" />

        <FinalCTA data-id="element-16" />

        <Footer data-id="element-17" />
      </main>
    </CurrencyProvider>;
}